var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapCustomMarker',{attrs:{"offsetY":45,"marker":_vm.marker,"alignment":"bottom"}},[_c('div',{staticClass:"vehicle-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('McButton',{attrs:{"size":"sm","text":_vm.$t('fleetTaskInstant.action.assign')},on:{"click":_vm.handleAssignVehicle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }